import { render, staticRenderFns } from "./cardEducationEdit.vue?vue&type=template&id=0b4d1dd4&scoped=true"
import script from "./cardEducationEdit.vue?vue&type=script&lang=js"
export * from "./cardEducationEdit.vue?vue&type=script&lang=js"
import style0 from "./cardEducationEdit.vue?vue&type=style&index=0&id=0b4d1dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d1dd4",
  null
  
)

export default component.exports